// @ts-nocheck
import { useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  setProjects,
  setActivateProject,
  setUserRoles,
  setindividualProjectStats,
  setUseProjectStats,
  setProjectAccessTable,
} from '../../toolkit/projectSlicer';
import ApiEndpoints from '../../const/ApiEndpoints';
import { SwalToast } from '../../components/Common';
import useConsole from '../Console/useConsole';
import utils from '../../utils/utils';
import { DATASET_REQUIRED_FIELDS } from '../../const/CommonConst';

/**
 * @function useProject
 * @description hook for ProjectOverview Module
 * @returns {object} -returning multiple methods and states for project overview module
 * @example const {createNewProject,fetchUserProjects,deleteProject,cloneProject }=useProject()
 */
export default function useProject() {
  const dispatch = useDispatch();
  const { project, user } = useSelector((state) => state);

  // without pagination
  const [datasetRowsWithoutPagination, setDatasetRowsWithoutPagination] =
    useState([]);

  const [datasetList, setDatasetList] = useState([]);
  const [datasetListPageCount, setDatasetListPageCount] = useState(0);
  const [datasetListTotalCount, setDatasetListTotalCount] = useState(0);
  // for storing unread task details
  const [userProjectUnreadTask, setUserProjectUnreadTask] = useState({});

  // with pagination
  const [datasetRowsWithPagination, setDatasetRowsWithPagination] = useState(
    []
  );
  const [datasetRowsPageCount, setDatasetRowPageCount] = useState(0);
  const [totalDatasetRows, setTotalDatasetRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [artifactList, setartifactList] = useState([]);
  const [totalArtifactList, settotalArtifactList] = useState(0);
  const [artifactListPageCount, setArtifactListPageCount] = useState(0);
  const [projectList, setprojectList] = useState([]);
  const [totalProjectList, settotalProjectList] = useState(0);
  const [projectListPageCount, setProjectListPageCount] = useState(0);

  const fetchIdRef = useRef(0);
  const BASE_URL = ApiEndpoints.MODULE_BASE_URL;
  const { fetchUdfs, udfs } = useConsole();
  const TOTAL_COUNT_HEADER = 'x-total-count';

  // User collection
  const fetchUserRecipients = (
    pageIndex,
    pageSize,
    searchTerm,
    successCallback = () => {}
  ) => {
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.DI.INV_USER_COLLECTION}`, {
        params: {
          ...(pageIndex ? { page_index: pageIndex } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchTerm ? { search_term: searchTerm } : {}),
        },
      })
      .then(
        (res) => {
          successCallback(res);
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };
  // sharing entity
  const submitSharingData = (body) =>
    axios.post(`${BASE_URL.DI}${ApiEndpoints.DI.INV_SHARING}`, body).then(
      (res) => {
        SwalToast({
          icon: 'success',
          title: res.data.msg,
        });
      },
      (error) => {
        throw error;
      }
    );

  // recived entity
  const fetchSentReceivedArtifacts = (successCallback = () => {}) =>
    axios.get(`${BASE_URL.DI}${ApiEndpoints.DI.INV_RECIVED}`).then(
      (res) => {
        successCallback(res);
      },
      (error) => {
        throw error;
      }
    );

  const fetchSentReceivedArtifactsPaginated = (
    pageIndex = 0,
    pageSize = 20,
    searchText = '',
    sortField = null,
    sortOrder = null,
    status = 'Sent',
    createdBy = null,
    artifacType = null
  ) =>
    axios
      .get(`${BASE_URL.DI}${ApiEndpoints.DI.INV_RECIVED_PAGINATED}`, {
        params: {
          page_index: pageIndex + 1,
          ...(createdBy ? { created_by: createdBy } : {}),
          ...(status ? { status } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchText ? { search_term: searchText } : {}),
          ...(sortField
            ? { sort_field: sortField }
            : { sort_field: 'shared_dt' }),
          ...(sortOrder ? { sort_order: sortOrder } : { sort_order: 'desc' }),
          ...(artifacType ? { type: artifacType } : {}),
        },
      })
      .then(
        (res) => {
          if (res.data) {
            setartifactList(res?.data);
            settotalArtifactList(res.headers[TOTAL_COUNT_HEADER]);
            setArtifactListPageCount(
              Math.ceil(res.headers[TOTAL_COUNT_HEADER] / pageSize)
            );
          } else {
            setartifactList([]);
            settotalArtifactList(0);
            setArtifactListPageCount(0);
          }
          return res;
        },
        (error) => {
          setartifactList([]);
          settotalArtifactList(0);
          setArtifactListPageCount(0);
          throw error;
        }
      );

  const fetchSentReceivedPipelines = () => {
    return axios
      .get(`${BASE_URL.DOC}${ApiEndpoints.PIPELINE.FETCH_SHARED_PIPELINE}`)
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  };

  // action of entity
  const acceptRejectArtifact = (body) =>
    axios.post(`${BASE_URL.DI}${ApiEndpoints.DI.INV_ACTION}`, body).then(
      // Change1
      (res) => res,
      (error) => {
        throw error;
      }
    );

  // Project
  /**
   * @function createNewProject
   * @description API call for creating new project
   * @param {object} body - data for creating project
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example createNewProject(body,successCallback,errorCallback);
   */
  const createNewProject = (
    body,
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios
      .post(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.CREATE_PROJECT}`,
        body
      )
      .then(
        (res) => {
          successCallback(res);
        },
        (error) => {
          errorCallback(error);
        }
      );
  const cloneProject = (body) =>
    axios
      .post(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.CLONE_PROJECT}`,
        body
      )
      .then(
        (resp) => {
          return resp;
        },
        (error) => {
          throw error;
        }
      );

  /**
   * @function shareProject
   * @description Shares a project.
   * @param {object} body - The data representing the project to be shared.
   * @returns {Promise} A Promise that resolves with the response data if successful, or rejects with an error.
   */
  const shareProject = (body) => {
    return axios
      .post(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.SHARE_PROJECT}`,
        body
      )
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  };

  /**
   * @function fetchSentReceivedProject
   * @description Fetches sent and received projects.
   * @returns {Promise} A Promise that resolves with the response data if successful, or rejects with an error.
   */
  const fetchSentReceivedProject = () => {
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.SHARE_PROJECT}`)
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  };

  const fetchSentReceivedProjectPaginated = (
    pageIndex = 0,
    pageSize = 20,
    searchText = '',
    sortField = null,
    sortOrder = null,
    status = 'Sent',
    createdBy = null
  ) =>
    axios
      .get(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.SHARE_PROJECT_PAGINATED}`,
        {
          params: {
            page_index: pageIndex + 1,
            ...(status ? { status } : {}),
            ...(pageSize ? { page_size: pageSize } : {}),
            ...(searchText ? { search_term: searchText } : {}),
            ...(sortField
              ? { sort_field: sortField }
              : { sort_field: 'shared_date' }),
            ...(sortOrder ? { sort_order: sortOrder } : { sort_order: 'desc' }),
            ...(createdBy ? { created_by: createdBy } : {}),
          },
        }
      )
      .then(
        (res) => {
          if (res.data) {
            setprojectList(res?.data);
            settotalProjectList(res.headers[TOTAL_COUNT_HEADER]);
            setProjectListPageCount(
              Math.ceil(res.headers[TOTAL_COUNT_HEADER] / pageSize)
            );
          } else {
            setprojectList([]);
            settotalProjectList(0);
            setProjectListPageCount(0);
          }
          return res;
        },
        (error) => {
          setprojectList([]);
          settotalProjectList(0);
          setProjectListPageCount(0);
          throw error;
        }
      );

  /**
   * @function acceptProject
   * @description Accepts a project.
   * @param {object} body - The data representing the project to be accepted.
   * @returns {Promise} A Promise that resolves with the response data if successful, or rejects with an error.
   */
  const acceptProject = (body) =>
    axios
      .post(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.ACTION_PROJECT}`,
        body
      )
      .then((res) => res)
      .catch((e) => {
        throw e;
      });

  /**
   * @function rejectProject
   * @description Rejects a project.
   * @param {number} id - The ID of the project to be rejected.
   * @param {object} rejectDatePayload - The payload containing data for rejecting the project.
   * @returns {Promise} A Promise that resolves with the response data if successful, or rejects with an error.
   */
  const rejectProject = (id, rejectDatePayload) =>
    axios
      .put(`${BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.ACTION_PROJECT}`, {
        id,
        ...rejectDatePayload,
      })
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );

  /**
   * @function updateProject
   * @description Updates a project.
   * @param {object} body - The data representing the project to be updated.
   * @returns {Promise} A Promise that resolves with the response data if successful, or rejects with an error.
   */
  const updateProject = (body) => {
    return axios
      .put(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.UPDATE_PROJECT}`,
        body
      )
      .then(
        (res) => res,
        (error) => {
          throw error;
        }
      );
  };
  /**
   * @function fetchUserProjects
   * @description API call for fetching user projects
   * @param {object} body - data for fetching user projects
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example fetchUserProjects(body,successCallback,errorCallback);
   */
  const fetchUserProjects = (field = '', hideLoaderOnRequest = false) =>
    axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECTS}`, {
        params: {
          ...(field ? { fields: field } : {}),
        },
        loader: !hideLoaderOnRequest,
      })
      .then(
        (res) => {
          dispatch(setProjects(res?.data));
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const [totalCount, setTotalCount] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [projectListData, setProjectListData] = useState([]);
  const [fetchPaginatedProjectsLoading, setFetchPaginatedProjectsLoading] =
    useState(false);

  const fetchPaginatedProjects = async (
    pageIndex,
    pageSize,
    searchTerm,
    projectType,
    modelType,
    sortField,
    sortOrder,
    hideLoaderOnRequest = false
  ) => {
    setFetchPaginatedProjectsLoading(true);
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECTS}`, {
        params: {
          page_index: pageIndex,
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchTerm ? { search_term: searchTerm } : {}),
          ...(sortField ? { sort_field: sortField } : {}),
          ...(sortOrder ? { sort_order: sortOrder } : {}),
          ...(modelType ? { model_type: modelType } : {}),
          ...(projectType ? { project_type: projectType } : {}),
        },
        loader: !hideLoaderOnRequest,
      })
      .then(
        (res) => {
          setFetchPaginatedProjectsLoading(false);
          return res;
        },
        (error) => {
          setFetchPaginatedProjectsLoading(false);
          throw error;
        }
      );
  };

  const fetchPaginatedProjectsForTable = async (
    pageIndex,
    pageSize,
    searchTerm,
    projectType,
    modelType,
    sortField,
    sortOrder,
    hideLoaderOnRequest = false
  ) => {
    try {
      const res = await fetchPaginatedProjects(
        pageIndex + 1,
        pageSize,
        searchTerm,
        projectType,
        modelType,
        sortField,
        sortOrder,
        hideLoaderOnRequest
      );

      setTotalCount(res.headers['x-total-count']);
      setPageCount(Math.ceil(res.headers['x-total-count'] / pageSize));

      if (res?.data?.length > 0) {
        setProjectListData(res?.data);
        return res?.data;
      }
    } catch (error) {
      return error;
    }
  };

  /**
   * Fetches project details based on the provided project ID.
   *
   * @param {number} projectId - The ID of the project to fetch details for
   * @return {Promise} AxiosPromise containing the project details
   */

  const fetchProjectDetails = (projectId) => {
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECTS}`, {
        params: {
          project_id: projectId,
        },
      })
      .then(
        (resp) => resp,
        (error) => {
          throw error;
        }
      );
  };

  /**
   * @function fetchUserUnreadTaskSubmodulewise
   * @description API call for fetching unread jobs for current project
   * @param {project_Id}  active project id
   * @returns {Promise} AxiosPromise
   * @example fetchUserUnreadTaskSubmodulewise(project_id);
   */

  const fetchUserUnreadTaskSubmodulewise = (projectId) => {
    axios
      .get(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECT_DETAILS}`,
        {
          params: { project_id: projectId },
          loader: false,
        }
      )
      .then((res) => {
        setUserProjectUnreadTask(res.data);
      });
  };

  /**
   * @function deleteProject
   * @description API call for delete project
   * @param {number} projectId - projectId to be deleted
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example deleteProject(projectId,successCallback,errorCallback);
   */
  const deleteProject = (
    projectId,
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios
      .delete(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.DELETE_PROJECT}`,
        { data: { project_id: projectId } }
      )
      .then(
        (res) => {
          fetchUserProjects(
            [
              'project_id',
              'clone_status',
              'share_status',
              'name',
              'is_archived',
              'regulation',
              'user_id',
              'is_completed',
              'is_collaborative',
              'system_generated_flag',
              'system_name',
              'type',
            ].join()
          ).then();
          // eslint-disable-next-line no-use-before-define
          fetchUserProjectsStatus();
          successCallback(res);
        },
        (error) => {
          errorCallback(error);
          throw error;
        }
      );

  /**
   * @function archiveProject
   * @description Archives a project.
   * @param {number} projectId - The ID of the project to be archived.
   * @returns {Promise} A Promise that resolves if the project is successfully archived, or rejects with an error.
   */
  const archiveProject = (projectId) => {
    return axios
      .delete(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.ARCHIVE_PROJECT}`,
        {
          data: { project_id: projectId },
        }
      )
      .then(
        () => {
          fetchUserProjects(
            [
              'project_id',
              'clone_status',
              'share_status',
              'name',
              'is_archived',
              'regulation',
              'user_id',
              'is_completed',
              'is_collaborative',
              'system_generated_flag',
              'system_name',
              'type',
            ].join()
          ).then();
          // eslint-disable-next-line no-use-before-define
          fetchUserProjectsStatus();
        },
        (error) => {
          throw error;
        }
      );
  };
  /**
   * @function unarchiveProject
   * @description Restores an archived project.
   * @param {number} projectId - The ID of the project to be restored.
   * @returns {Promise} A Promise that resolves if the project is successfully restored, or rejects with an error.
   */
  const unarchiveProject = (projectId) =>
    axios
      .post(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.RESTORE_PROJECT}`,
        { project_id: projectId }
      )
      .then(
        () => {
          fetchUserProjects(
            [
              'project_id',
              'clone_status',
              'share_status',
              'name',
              'is_archived',
              'regulation',
              'user_id',
              'is_completed',
              'is_collaborative',
              'system_generated_flag',
              'system_name',
              'type',
            ].join()
          ).then();
        },
        (error) => {
          throw error;
        }
      );

  /**
   * @function fetchUserRoles
   * @description API call for fetching user roles
   * @param {object} body - data for fetching user roles
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example fetchUserRoles(body,successCallback,errorCallback);
   */
  const fetchUserRoles = (
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_ROLES}`)
      .then(
        (res) => {
          dispatch(setUserRoles(res.data));
          successCallback(res);
        },
        (error) => {
          errorCallback(error);
        }
      );

  /**
   * @function fetchIndividualProjectStats
   * @description API call for fetching individual project stats
   * @param {object} body - data for fetching individual project stats
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example fetchIndividualProjectStats(body,successCallback,errorCallback);
   */
  const fetchIndividualProjectStats = (body) =>
    axios
      .get(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.FETCH_INDIVIDUAL_PROJECT_STATS}/${body}`
      )
      .then((res) => {
        dispatch(setindividualProjectStats(res.data));
        fetchUserProjects(
          [
            'project_id',
            'clone_status',
            'share_status',
            'name',
            'is_archived',
            'regulation',
            'user_id',
            'is_completed',
            'is_collaborative',
            'system_generated_flag',
            'system_name',
            'type',
          ].join()
        ).then();
        return res;
      });

  /**
   * @function fetchUserProjectsStatus
   * @description API call for fetching user projects status
   * @param {object} body - data for fetching user projects status
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example fetchUserProjectsStatus(body,successCallback,errorCallback);
   */
  const fetchUserProjectsStatus = (
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios
      .get(
        `${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECTS_STATUS}`
      )
      .then(
        (res) => {
          dispatch(setUseProjectStats(res.data));
          successCallback(res);
        },
        (error) => {
          errorCallback(error);
        }
      );

  /**
   * @function fetchProjectTypes
   * @description API call for fetching user projects status
   * @returns {Promise} AxiosPromise
   * @example fetchProjectTypes(body,successCallback,errorCallback);
   */

  const fetchProjectTypes = () => {
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.PROJECT_TYPE}`)
      .then((res) => res.data)
      .catch((error) => {
        throw error;
      });
  };

  /**
   * @function fetchDatasetList
   * @description Fetches a list of datasets.
   * @param {number} projectId - The ID of the project associated with the datasets.
   * @param {boolean} lite - Flag indicating whether to fetch lite dataset list or full dataset list.
   * @param {string} field - The field to filter datasets by.
   * @param {number} pageIndex - The index of the page to fetch.
   * @param {number} pageSize - The size of each page in the dataset list.
   * @param {string} searchText - The text to search for in the dataset names.
   * @returns {Promise} A Promise that resolves with the dataset list data if successful, or rejects with an error.
   */
  const fetchDatasetList = (
    projectId = null,
    lite = true,
    field = '',
    pageIndex = 0,
    pageSize = 10,
    searchText = '',
    sortField = null,
    sortOrder = null,
    hideLoaderOnRequest
  ) => {
    if (projectId !== undefined) {
      if (!lite) {
        return axios
          .get(`${BASE_URL.DI}${ApiEndpoints.DI.DATAMANAGE_DATASETS}`, {
            params: {
              page_index: pageIndex + 1,
              ...(projectId ? { project_id: projectId } : {}),
              ...(pageSize ? { page_size: pageSize } : {}),
              ...(searchText ? { search_term: searchText } : {}),
              ...(sortField ? { sort_field: sortField } : {}),
              ...(sortOrder ? { sort_order: sortOrder } : {}),
            },
            loader: !hideLoaderOnRequest,
          })
          .then(
            (res) => {
              if (res.data) {
                setIsLoading(false);
                setDatasetList(res.data);
                setDatasetListTotalCount(res.headers[TOTAL_COUNT_HEADER]);
                setDatasetListPageCount(
                  Math.ceil(res.headers[TOTAL_COUNT_HEADER] / pageSize)
                );
              } else {
                setIsLoading(false);
                setDatasetList([]);
                setDatasetListPageCount(0);
                setDatasetListTotalCount(0);
              }
              return res;
            },
            (e) => {
              setIsLoading(false);
              setDatasetList([]);
              setDatasetListPageCount(0);
              setDatasetListTotalCount(0);
              throw e;
            }
          );
      }
      return axios
        .get(`${BASE_URL.DI}${ApiEndpoints.DI.DATAMANAGE_DATASETS}`, {
          params: {
            ...(projectId ? { project_id: projectId } : {}),
            ...(field ? { fields: field } : {}),
          },
          loader: !hideLoaderOnRequest,
        })
        .then(
          (res) => {
            if (res.data) {
              setIsLoading(false);
              setDatasetList(res.data);
            } else {
              setIsLoading(false);
              setDatasetList([]);
              setDatasetListPageCount(0);
              setDatasetListTotalCount(0);
            }
            return res;
          },
          (e) => {
            setIsLoading(false);
            setDatasetList([]);
            setDatasetListPageCount(0);
            setDatasetListTotalCount(0);
            throw e;
          }
        );
    }
  };

  /**
   * @function fetchDatasetList
   * @description Fetches a list of datasets.
   * @param {number} projectId - The ID of the project associated with the datasets.
   * @param {boolean} lite - Flag indicating whether to fetch lite dataset list or full dataset list.
   * @param {string} field - The field to filter datasets by.
   * @param {number} pageIndex - The index of the page to fetch.
   * @param {number} pageSize - The size of each page in the dataset list.
   * @param {string} searchText - The text to search for in the dataset names.
   * @returns {Promise} A Promise that resolves with the dataset list data if successful, or rejects with an error.
   */
  const fetchDatasetListWithModelId = (modelId, projectId, field = '') => {
    return axios
      .get(`${BASE_URL.DI}${ApiEndpoints.DI.DATAMANAGE_DATASETS}`, {
        params: {
          ...(modelId ? { model_id: modelId } : {}),
          ...(projectId ? { project_id: projectId } : {}),
          ...(field ? { fields: field } : {}),
        },
      })
      .then(
        (res) => {
          if (res.data) {
            return res;
          }
        },
        (e) => {
          throw e;
        }
      );
  };

  /**
   * @function fetchDatasetRowsWithoutPagination
   * @description API call for fetching dataset rows without pagination
   * @param {number} datasetID -fetchingdataset rows without pagination of particular dataset id
   * @returns {Promise} AxiosPromise
   * @example fetchDatasetRowsWithoutPagination(datasetID);
   */
  const fetchDatasetRowsWithoutPagination = (datasetID) => {
    setIsLoading(true);
    return axios
      .get(`${BASE_URL.GR}${ApiEndpoints.DM.DATASETS}`, {
        params: {
          dataset_id: datasetID,
        },
      })
      .then(
        (res) => {
          if (res.data.response) {
            setIsLoading(false);
            setDatasetRowsWithoutPagination(res.data.response);
          } else {
            setIsLoading(false);
            setDatasetRowsWithoutPagination([]);
          }
          return res;
        },
        (e) => {
          setIsLoading(false);
          setDatasetRowsWithoutPagination([]);
          throw e;
        }
      );
  };

  /**
   * @function fetchDatasetRowsWithPagination
   * @description API call for fetching dataset rows with pagination
   * @param {number} datasetId -fetchingdataset rows with pagination of particular dataset id
   * @param {number} pageIndex - fetching dataset rows with page index
   * @param {number} pageSize - fetching dataset rows with pagesize
   * @param {string} searchText - text to be searched
   * @returns {Promise} AxiosPromise
   * @example fetchDatasetRowsWithPagination(datasetId,pageIndex,pageSize,searchText);
   */
  const fetchDatasetRowsWithPagination = useCallback(
    (
      datasetId,
      pageIndex = 0,
      pageSize = 500,
      searchText = '',
      project_id = null,
      hideLoaderOnRequest = false
    ) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server.

      // Give this fetch an ID
      // eslint-disable-next-line no-plusplus
      const fetchId = ++fetchIdRef.current;

      // Your server could send back total page count.
      setIsLoading(true);
      return axios
        .get(`${BASE_URL.GR}${ApiEndpoints.DM.DATASETS}`, {
          params: {
            project_id,
            dataset_id: datasetId,
            page: pageIndex + 1,
            ...(pageSize ? { pagesize: pageSize } : {}),
            ...(searchText ? { search: searchText } : {}),
          },
          loader: !hideLoaderOnRequest,
        })
        .then(
          (res) => {
            if (res.data.response) {
              setIsLoading(false);
              if (fetchId === fetchIdRef.current) {
                setDatasetRowsWithPagination(res.data.response);
                setTotalDatasetRows(res.headers[TOTAL_COUNT_HEADER]);
                setDatasetRowPageCount(
                  Math.ceil(res.headers[TOTAL_COUNT_HEADER] / pageSize)
                );
              }
            } else {
              setIsLoading(false);
              setDatasetRowsWithPagination([]);
              setDatasetRowPageCount(0);
              setTotalDatasetRows(0);
            }
            return res;
          },
          (e) => {
            setIsLoading(false);
            setDatasetRowsWithPagination([]);
            setDatasetRowPageCount(0);
            setTotalDatasetRows(0);
            throw e;
          }
        );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  /**
   * @function updateDatasetCells
   * @description API call for updating dataset cells
   * @param {number} datasetID -updating dataset cells of particular dataset id
   * @param {Object} cells - dataset cells
   * @param {function} successCallback - Callback function to execute upon completion of API call
   * @param {function} errorCallback - Callback function to execute when any error happens during the calling of API
   * @returns {Promise} AxiosPromise
   * @example  updateDatasetCells(datasetID,cells,successCallback,errorCallback)
   */
  const updateDatasetCells = (
    cells = {},
    successCallback = () => {},
    errorCallback = () => {}
  ) =>
    axios.put(`${BASE_URL.DM}${ApiEndpoints.GRID.EDIT_CELL}`, cells).then(
      (resp) => {
        if (successCallback) {
          successCallback(resp);
        }
      },
      (err) => {
        if (errorCallback) {
          errorCallback(err);
        }
      }
    );
  /**
   * @function fetchModuleTasks
   * @description API call for fetching module tasks
   * @param {string} module -module to be fetched
   * @param {object} operation - operation
   * @param {string} endpoint - API endpoints
   * @param {function} setModuleTasks -setting module tasks
   * @param {number} project_id - project id
   * @param {boolean} hideLoaderOnRequest - hiding loader on request
   * @returns {Promise} AxiosPromise
   * @example  fetchModuleTasks(module,operation,endpoint,setModuleTasks,project_id,hideLoaderOnRequest)
   */
  const fetchModuleTasks = (
    module,
    operation,
    endpoint,
    setModuleTasks,
    // eslint-disable-next-line camelcase
    project_id,
    hideLoaderOnRequest,
    moduleName,
    pageIndex,
    pageSize,
    taskStatus,
    count = false,
    moduleNameFilter
  ) => {
    return axios
      .get(
        `${
          ApiEndpoints.MODULE_BASE_URL[module] + ApiEndpoints[module][endpoint]
        }`,
        {
          params: {
            operation,
            project_id,
            ...(moduleName ? { module: moduleName } : null),
            ...(pageIndex ? { page_index: pageIndex } : null),
            ...(pageSize ? { page_size: pageSize } : {}),
            ...(taskStatus ? { task_status: taskStatus } : {}),
            ...(count ? { count } : {}),
            ...(moduleNameFilter ? { module: moduleNameFilter } : null),
          },
          loader: !hideLoaderOnRequest,
        }
      )
      .then(
        (res) => {
          if (!count) {
            setModuleTasks(res.data?.tasks || []);
            if (pageIndex === 1) {
              fetchDatasetList(
                project?.activeProject?.project_id,
                true,
                [DATASET_REQUIRED_FIELDS, 'fields'].join(),
                null,
                null,
                null,
                null,
                null,
                hideLoaderOnRequest
              );
            }
          }
          return res;
        },
        () => {}
      );
  };

  /**
   * @function saveChartComment
   * @description API call for saving chart comment
   * @param {object} body -data for saving chart comment
   * @param {boolean} isConsole - if true then console API is called
   * @returns {Promise} AxiosPromise
   * @example  saveChartComment(body)
   */
  const saveChartComment = (body, isConsole, successCallback = () => {}) => {
    const baseUrl = utils.getModuleBaseUrl(body.module, body.sub_module);
    const url = isConsole
      ? BASE_URL.CONSOLE + ApiEndpoints.UDF_MANAGER.SAVE_CHART
      : `${baseUrl}${ApiEndpoints.SAVE_CHART_COMMENT}`;
    // eslint-disable-next-line no-param-reassign
    delete body.api;
    // eslint-disable-next-line no-param-reassign
    delete body.moduleRoute;
    return (
      axios.post(url, body).then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'Comment submitted successfully.',
          });
          successCallback(res);
        },
        () => {}
      ),
      body.moduleRoute
    );
  };

  /**
   * @function saveTableComment
   * @description API call for saving table comment
   * @param {object} body -data for saving table comment
   * @param {boolean} isConsole - if true then console API is called
   * @returns {Promise} AxiosPromise
   * @example  saveTableComment(body)
   */
  const saveTableComment = (body, isConsole, successCallback = () => {}) => {
    const baseUrl = utils.getModuleBaseUrl(body.module, body.sub_module);
    const url = isConsole
      ? BASE_URL.CONSOLE + ApiEndpoints.UDF_MANAGER.SAVE_TABLE
      : `${baseUrl}${ApiEndpoints.SAVE_TABLE_COMMENT}`;
    return (
      axios.post(url, body).then(
        (res) => {
          SwalToast({
            icon: 'success',
            title: 'Comment submitted successfully.',
          });
          successCallback(res);
        },
        () => {}
      ),
      body.moduleRoute
    );
  };

  /**
   * @function refreshGridOnSuccess
   * @description API call for refresh grid on success
   * @param {number} dataSetId - dataset id
   * @returns {undefined}
   * @example  refreshGridOnSuccess(dataSetId)
   */
  const refreshGridOnSuccess = (dataSetId) => {
    if (
      dataSetId &&
      document.getElementById(`dataset-table-${dataSetId}-refresh-btn`)
    ) {
      document
        .getElementById(`dataset-table-${dataSetId}-refresh-btn`)
        ?.click();
    }
  };

  /**
   * @function fetchProjectAccessTable
   * @description API call for fetch project access table
   * @param {number} projectId -project id
   * @returns {Promise} AxiosPromise
   * @example  fetchProjectAccessTable(projectId)
   */
  const fetchProjectAccessTable = (projectId) => {
    if (projectId) {
      return axios
        .get(
          `${
            BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.PROJECT_ACCESS_TABLE
          }/${projectId}`
        )
        .then(
          (resp) => {
            dispatch(setProjectAccessTable(resp.data));
            return resp;
          },
          (e) => {
            dispatch(setProjectAccessTable([]));
            return Promise.reject(e);
          }
        );
    }
  };

  /**
   * @function fetchWorkflowDetails
   * @description API call for fetch workflow details
   * @param {object} body -body as data in params
   * @returns {Promise} AxiosPromise
   * @example  fetchWorkflowDetails(body)
   */

  const fetchWorkflowDetails = (body) => {
    // {{url}}/data-management/projectmanagement/workflow?project_id=73
    return axios
      .get(
        `${`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.FETCH_PROJECT_WORKFLOW_DETAILS}`}`,
        {
          params: body,
        }
      )
      .then((res) => {
        return res;
      });
  };

  /**
   * @function updateProjectAccessTable
   * @description API call for update project access table
   * @param {object} payload -payload data
   * @returns {Promise} AxiosPromise
   * @example  updateProjectAccessTable(payload)
   */
  const updateProjectAccessTable = (payload) => {
    if (payload) {
      return axios
        .post(
          BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.PROJECT_ACCESS_TABLE,
          payload
        )
        .then(
          (resp) => resp,
          (e) => Promise.reject(e)
        );
    }
  };

  /**
   * @function validateAndActivateProject
   * @description This function is used to validate the project
   * and activate the project if it is valid
   * @param {Object} _project
   * @returns {void}
   */
  const validateAndActivateProject = (_project) => {
    if (
      !_project.is_archived &&
      ['NotStarted', 'Success'].includes(_project?.clone_status) &&
      ['NotStarted', 'Success'].includes(_project?.share_status)
    ) {
      fetchProjectDetails(_project?.project_id).then((res) => {
        dispatch(setActivateProject(res.data));
      });
    } else {
      if (_project.is_archived) {
        SwalToast({
          icon: 'info',
          title: 'This project is archived.',
        });
      }
      if (_project?.share_status === 'InProgress') {
        SwalToast({
          icon: 'info',
          title: 'Project accepting is in progress. Please wait for sometime.',
        });
      }
      if (_project?.share_status === 'Failed') {
        SwalToast({
          icon: 'error',
          title: `Project accepting failed. Reason: ${_project?.share_failure_msg}`,
        });
      }
      if (_project?.clone_status === 'InProgress') {
        SwalToast({
          icon: 'info',
          title: 'Project cloning is in progress. Please wait for sometime.',
        });
      }
      if (_project?.clone_status === 'Failed') {
        SwalToast({
          icon: 'error',
          title: `Project cloning failed. Reason: ${_project?.clone_failure_msg}`,
        });
      }
    }
  };

  const fetchProjectLevelPermission = (projectId, userId) => {
    const params = {};

    if (projectId) {
      params.project_id = projectId;
    }

    if (userId) {
      params.user_id = userId;
    }
    if (Object.keys(params).length > 0) {
      return axios
        .get(
          `${`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.PROJECT_PERMISSION}`}`,
          {
            params,
          }
        )
        .then(
          (resp) => {
            return resp;
          },
          (e) => {
            return Promise.reject(e);
          }
        );
    }
  };

  const fetchAllLockedArtifactsByProjectId = (projectId, pageIndex, pageSize) =>
    axios
      .get(
        BASE_URL.DI +
          ApiEndpoints.PROJECT_MANAGEMENT.GET_LOCKED_PROJECT_ARTIFACTS,
        {
          params: {
            ...(pageIndex >= 0 ? { page_index: pageIndex + 1 } : {}),
            ...(projectId ? { project_id: projectId } : {}),
            ...(pageSize ? { page_size: pageSize } : {}),
          },
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const lockArtifact = (payload) => {
    if (payload) {
      return axios
        .post(
          BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.LOCK_ARTIFACT,
          payload
        )
        .then(
          (resp) => resp,
          (e) => Promise.reject(e)
        );
    }
  };
  const getLockArtifact = (param) =>
    axios
      .get(BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.LOCK_ARTIFACT, {
        params: param,
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );

  const unlockArtifact = (payload) =>
    axios
      .post(
        BASE_URL.DI +
          ApiEndpoints.PROJECT_MANAGEMENT.RECALIBERATE_LOCKED_ARTIFACT,
        payload
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  const markProjectCompleted = (payload) =>
    axios
      .post(
        BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.MARK_PROJECT_COMPLETED,
        payload
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  const fetchGroups = (pageIndex, pageSize, searchTerm) =>
    axios
      .get(BASE_URL.DI + ApiEndpoints.DI.FETCH_GROUP_LISTS, {
        params: {
          ...(pageIndex ? { page_index: pageIndex } : {}),
          ...(pageSize ? { page_size: pageSize } : {}),
          ...(searchTerm ? { search_term: searchTerm } : {}),
        },
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  const fetchProjects = (payload, hideLoaderOnRequest = false) =>
    axios
      .get(`${BASE_URL.DI}${ApiEndpoints.PROJECT_MANAGEMENT.USER_PROJECTS}`, {
        params: {
          page_index: 1,
          page_size: 20,
          ...payload,
        },
        loader: !hideLoaderOnRequest,
      })
      .then(
        (res) => {
          return res?.data;
        },
        (error) => {
          throw error;
        }
      );
  const fetchCollaboratorsPermission = (entity) => {
    return axios
      .get(BASE_URL.DI + ApiEndpoints.AUTH.GET_COLLABORATORS_PERMISSIONS, {
        params: entity,
      })
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };
  const getVaultRedirectUrl = (params) => {
    return axios
      .get(
        `${
          ApiEndpoints.MODULE_BASE_URL.DI +
          ApiEndpoints.PROJECT_MANAGEMENT.MRM_VAULT_REDIRECT_URL
        }`,
        {
          ...(params ? { params } : {}),
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          return error;
        }
      );
  };
  return {
    // Shorthand properties
    fetchGroups,
    datasetList,
    datasetListPageCount,
    datasetListTotalCount,
    fetchDatasetList,
    fetchDatasetRowsWithoutPagination,
    fetchModuleTasks,
    saveTableComment,
    saveChartComment,
    datasetRowsWithoutPagination,
    setDatasetRowsWithoutPagination,

    datasetRowsWithPagination,
    setDatasetRowsWithPagination,

    totalDatasetRows,
    fetchDatasetRowsWithPagination,
    datasetRowsPageCount,
    isLoading,
    updateDatasetCells,
    artifactList,
    totalArtifactList,
    artifactListPageCount,
    setartifactList,
    fetchSentReceivedArtifactsPaginated,
    projectList,
    totalProjectList,
    projectListPageCount,
    setprojectList,
    projectListData,
    fetchSentReceivedProjectPaginated,
    fetchCollaboratorsPermission,

    // Project
    project,
    totalCount,
    pageCount,
    createNewProject,
    fetchProjectDetails,
    cloneProject,
    deleteProject,
    shareProject,
    fetchUserProjects,
    fetchUserRoles,
    fetchIndividualProjectStats,
    fetchUserProjectsStatus,
    fetchUserRecipients,
    submitSharingData,
    fetchSentReceivedArtifacts,
    fetchSentReceivedProject,
    fetchSentReceivedPipelines,
    acceptProject,
    rejectProject,
    acceptRejectArtifact,
    fetchProjectLevelPermission,
    fetchDatasetListWithModelId,
    fetchProjects,
    activateProject(data) {
      if (data?.project_id) {
        fetchProjectDetails(data?.project_id).then((res) => {
          dispatch(setActivateProject(res.data));
        });
      } else {
        dispatch(setActivateProject(data));
      }
    },
    lockArtifact,
    refreshGridOnSuccess,
    fetchProjectAccessTable,
    updateProjectAccessTable,
    updateProject,
    unarchiveProject,
    archiveProject,
    fetchWorkflowDetails,
    fetchUserUnreadTaskSubmodulewise,
    userProjectUnreadTask,
    fetchUdfs,
    udfs,
    validateAndActivateProject,
    fetchProjectTypes,
    setDatasetListTotalCount,
    setDatasetListPageCount,
    user,
    fetchAllLockedArtifactsByProjectId,
    unlockArtifact,
    getLockArtifact,
    markProjectCompleted,
    fetchPaginatedProjects,
    fetchPaginatedProjectsForTable,
    fetchPaginatedProjectsLoading,
    getVaultRedirectUrl,
  };
}
